import {
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { Router } from "@angular/router";
import {
  NbComponentStatus,
  NbDialogService,
  NbGlobalPhysicalPosition,
  NbMenuItem,
  NbMenuService,
  NbThemeService,
  NbToastrService,
} from "@nebular/theme";

import { ProductService } from "../../services/product.service";

import { UserService } from "../../@core/services/user.service";
import { User } from "../../@core/data/users";
import { filter, map, takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";

import { Catalog, Product } from "../../models/product.model";
import * as _ from "lodash";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { DOUBLE_PATTERN } from "../../@auth/components/constants";
import { DialogYesNoPromptComponent } from "../dialog-yesno-prompt/dialog-yesno-prompt.component";
import { DialogProductComponent } from "../dialog-product/dialog-product.component";
import { CatalogService } from "../../services/catalog.service";
import { environment } from "../../../environments/environment";
import { convertTimestamp } from "../../@core/utils/convertTimestamps.service";
import { Hotkeys } from "../../@core/utils/hotkeys.service";
import Shop from "../../models/shop.model";
import { DialogProductInventoriesComponent } from "../dialog-product-inventories/dialog-product-inventories.component";

@Component({
  selector: "ngx-view-table-pagination-products",
  styleUrls: ["./view-table-pagination-products.component.scss"],
  templateUrl: "./view-table-pagination-products.component.html",
})
export class ViewTablePaginationProductsComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  private destroy$: Subject<void> = new Subject<void>();
  @Input() shopId?: string = "";
  @Input() shop?: Shop;
  @Input() mode?: string = "receipt"; //receipt/purchase/trade/products/loan
  @Input() units?: Catalog[] = [];
  @Input() groups?: Catalog[] = [];
  @Input() categories?: Catalog[] = [];
  @Input() suppliers?: Catalog[] = [];
  @Input() producers?: Catalog[] = [];
  @Input() origins?: Catalog[] = [];
  @Input() sizes?: Catalog[] = [];
  @Input() colors?: Catalog[] = [];
  @Output() onSelectedProduct: EventEmitter<any> = new EventEmitter();
  @Output() onNewProduct: EventEmitter<any> = new EventEmitter();

  display?: Product[] = [];
  user: User;
  product: Product = new Product();
  loading: boolean = false;
  submitted = false;
  diaForm: FormGroup;

  @ViewChild("title") title: ElementRef;
  @ViewChild("strQuantity") strQuantity: ElementRef;
  @ViewChild("createUnit") createUnit: ElementRef;
  @ViewChild("createPrice") createPrice: ElementRef;
  isCreate: boolean = false;
  strSearch: string = "";
  uid = "anonymous";
  isProduct = false;
  filterCatalog = false;
  selectedCatalog = "";
  page: number = 1;
  itemsPerPage: number = 10;

  formatCurrency: string = environment.formatCurrency
    ? environment.formatCurrency
    : "#,###,###,###";

  groupSelected: string = "";
  categorySelected: string = "";
  indexSelected: number = 0;
  quantity: string = "";

  constructor(
    private userService: UserService,
    private productService: ProductService,
    private router: Router,
    private fb: FormBuilder,
    private dialogService: NbDialogService,
    private catalogService: CatalogService,
    private toastrService: NbToastrService,
    private themeService: NbThemeService,
    private nbMenuService: NbMenuService,
    private hotkeys: Hotkeys
  ) {
    hotkeys
      .addShortcut({ keys: "control.x" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log("hotkeys/control.x");
        this.title.nativeElement.focus();
        this.removeSearch();
      });

    hotkeys
      .addShortcut({ keys: "control.enter" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log("hotkeys/control.enter");
        this.strQuantity.nativeElement.focus();
      });

    hotkeys
      .addShortcut({ keys: "enter" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        console.log("hotkeys/enter/indexSelected:", this.indexSelected);
        this.title.nativeElement.focus();

        const index = this.indexSelected + (this.page - 1) * this.itemsPerPage;

        console.log("hotkeys/enter/index:", index);
        if (index < this.display.length) {
          console.log("hotkeys/enter/item:", this.display[index].barcode);
          this.selected(this.display[index]);
        }
      });

    hotkeys
      .addShortcut({ keys: "arrowup" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const pages: number = Math.ceil(this.display.length / 10);
        //first item of page view
        if (this.indexSelected === 0) {
          if (this.page > 1) {
            this.indexSelected = this.itemsPerPage - 1;
            this.page--;
          }
        } else {
          this.indexSelected--;
        }

        console.log("hotkeys/shift.up:", this.indexSelected);
        this.title.nativeElement.focus();
      });

    hotkeys
      .addShortcut({ keys: "arrowdown" })
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        const pages: number = Math.ceil(this.display.length / 10);
        //last item of page view
        if (this.indexSelected === this.itemsPerPage - 1) {
          if (this.page < pages) {
            this.indexSelected = 0;
            this.page++;
          }
        } else {
          const index =
            this.indexSelected + (this.page - 1) * this.itemsPerPage;
          if (index < this.display.length - 1) {
            this.indexSelected++;
          }
        }

        console.log("hotkeys/shift.down:", this.indexSelected);

        this.title.nativeElement.focus();
      });
  }

  ngOnInit(): void {
    this.userService
      .getCurrentUser()
      .pipe(takeUntil(this.destroy$))
      .subscribe((user: User) => {
        if (user && user.uid != this.uid) {
          this.uid = user.uid;
          this.user = user;
          if (user.moderator || user.product) {
            this.isProduct = true;
          }

          if (
            this.productService.products &&
            this.productService.products.length > 0
          ) {
            this.display = [...this.productService.products];
          }

          if (!this.shopId || this.shopId == "") {
            this.shopId = user.shopId;
          }

          if (this.mode !== "products") {
            this.getCatalogs();
          }
        } else {
          this.uid = "anonymous";
        }
      });

    const titleValidators = [
      Validators.minLength(1),
      Validators.maxLength(250),
      Validators.required,
    ];
    const priceValidators = [Validators.pattern(DOUBLE_PATTERN)];

    this.diaForm = this.fb.group({
      title: ["", titleValidators],
      price: ["", priceValidators],
      costPrice: ["", priceValidators],
      quantity: ["", priceValidators],
      unit: [],
      groupSelected: [],
      categorySelected: [],
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngAfterViewInit() {
    if (this.title) {
      setTimeout(() => {
        this.title.nativeElement.focus();
      }, 1000);
    }
  }

  getCatalogs(): void {
    // this.loading = true;

    this.catalogService
      .getCatalogs(this.shopId)
      .snapshotChanges(["added", "removed"])
      .pipe(
        map((changes) =>
          changes.map((c) => ({
            id: c.payload.doc.id,
            ...c.payload.doc.data(),
          }))
        ),
        takeUntil(this.destroy$)
      )
      .subscribe(
        (data) => {
          this.units = [];
          this.groups = [];
          this.categories = [];
          this.suppliers = [];
          this.producers = [];
          this.origins = [];
          this.sizes = [];
          this.colors = [];
          _.forEach(data, (item) => {
            switch (item.mode) {
              case "units":
                this.units.push(item);
                break;
              case "groups":
                this.groups.push(item);
                break;
              case "categories":
                this.categories.push(item);
                break;
              case "producers":
                this.producers.push(item);
                break;
              case "origins":
                this.origins.push(item);
                break;
              case "sizes":
                this.sizes.push(item);
                break;
              case "colors":
                this.colors.push(item);
                break;
              default:
                break;
            }
          });

          this.loading = false;
        },
        (error) => {
          console.error("getCatalogs:", error);
          this.loading = false;
        }
      );
  }

  removeCatalog(mode) {
    if (mode === "groups") {
      this.groupSelected = "";
    }
    if (mode === "categories") {
      this.categorySelected = "";
    }
    this.onSearch();
  }

  onNew() {
    if (this.mode === "loan") {
      this.onNewProduct.emit(true);
    } else {
      this.product.isStock = true;
      this.dialogService
        .open(DialogProductComponent, {
          context: {
            header: "Tạo mặt hàng",
            user: this.user,
            mode: "new",
            // product: this.product,
            units: this.units,
            groups: this.groups,
            categories: this.categories,
            suppliers: this.suppliers,
            producers: this.producers,
            origins: this.origins,
            sizes: this.sizes,
            colors: this.colors,
            products: this.productService.products,
          },
          closeOnBackdropClick: false,
        })
        .onClose.subscribe((value) => {
          if (value) {
            console.log("🚀 ~ .onClose.subscribe ~ value:", value);
            this.display = [value, ...this.display];
            if (this.mode !== "products") {
              this.selected(value);
            }
          }
        });
    }
  }

  edit(item: Product) {
    let lecBk = new Product();
    lecBk = _.clone(item);
    this.dialogService
      .open(DialogProductComponent, {
        context: {
          header: "Cập nhật sản phẩm",
          user: this.user,
          mode: "edit",
          product: lecBk,
          units: this.units,
          groups: this.groups,
          categories: this.categories,
          suppliers: this.suppliers,
          producers: this.producers,
          origins: this.origins,
          sizes: this.sizes,
          colors: this.colors,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        console.log(
          "ViewTablePaginationProductsComponent/DialogProductComponent/edit",
          value
        );
        if (value) {
          this.strSearch = "";
          if (value.isDeleted) {
            //case delete
            const index = this.productService.products.indexOf(item);
            if (index > -1) this.productService.products.splice(index, 1);
            this.display = [...this.productService.products];
          }
        }
        this.onSearch();
      });
  }

  create() {
    this.strSearch = this.strSearch.trim();
    if (this.strSearch != "") {
      console.log(this.diaForm.value);

      let prod = new Product();
      prod.expDate = new Date();
      prod.shopId = this.shopId;
      prod.title = this.diaForm.value.title;
      prod.unitName = this.diaForm.value.unit ? this.diaForm.value.unit : "Cái";
      prod.price = parseFloat(this.diaForm.value.price.toString());
      prod.costPrice = parseFloat(this.diaForm.value.costPrice.toString());

      this.loading = true;
      this.submitted = true;

      this.productService
        .create(prod)
        .then((data) => {
          prod.id = data.id;

          this.diaForm.patchValue({
            price: "",
            costPrice: "",
            unit: "",
          });

          this.selected(prod);
          this.loading = false;
          this.submitted = false;
        })
        .catch((err) => {
          this.loading = false;
          this.submitted = false;
        });
    } else {
      this.elemFocus("title");
    }
  }

  selected(item: Product): void {
    item.price = item.price ? item.price : 0;
    item.wsPrice = item.wsPrice ? item.wsPrice : 0;
    item.costPrice = item.costPrice ? item.costPrice : 0;
    item.quantity = isNaN(parseFloat(this.quantity))
      ? 1
      : parseFloat(this.quantity);

    this.onSelectedProduct.emit(item);

    this.quantity = "";
    this.title.nativeElement.focus();
  }

  viewStock(item): void {
    console.log("selectedProduct/selected:", item);

    this.dialogService
      .open(DialogProductInventoriesComponent, {
        context: {
          shopId: this.shopId,
          product: item,
        },
        closeOnBackdropClick: false,
      })
      .onClose.subscribe((value) => {
        if (value.hadChange) {
          this.onSearch();
        }
      });
  }

  onSearch(): void {
    this.quantity = "";
    this.indexSelected = 0;
    this.page = 1;
    this.strSearch = this.strSearch ? this.strSearch.trim() : "";
    const strFilter = this.strSearch ? this.strSearch.toLowerCase() : "";
    const groupSelected = this.groupSelected ? this.groupSelected : "";
    const categorySelected = this.categorySelected ? this.categorySelected : "";

    this.loading = true;
    if (strFilter === "" && groupSelected === "" && categorySelected === "") {
      this.display = [...this.productService.products];
      this.loading = false;
    } else {
      this.display = _.filter(this.productService.products, function (item) {
        const title = item.title ? item.title.toLowerCase() : "";
        const description = item.description
          ? item.description.toLowerCase()
          : "";
        const barcode = item.barcode ? item.barcode.toLowerCase() : "";
        return (
          (groupSelected === "" || item.groupId == groupSelected) &&
          (categorySelected === "" || item.categoryId == categorySelected) &&
          ((title && title.includes(strFilter)) ||
            (description && description.includes(strFilter)) ||
            (barcode && barcode.includes(strFilter)))
        );
      });
    }
    this.loading = false;
  }

  removeSearch() {
    this.strSearch = "";
    this.title.nativeElement.focus();
    this.onSearch();
  }

  onSelected() {
    //
  }

  pageChange(page: number) {
    this.page = page;
    this.indexSelected = 0;
  }

  addProduct() {
    this.isCreate = !this.isCreate;
  }
  elemFocus(ctr: string) {
    switch (ctr) {
      case "createUnit":
        this.createUnit
          ? this.createUnit.nativeElement.focus()
          : (this.isCreate = true);
        break;
      case "createPrice":
        this.createPrice
          ? this.createPrice.nativeElement.focus()
          : (this.isCreate = true);
        break;
      case "title":
        this.title.nativeElement.focus();
        break;
      default:
        this.title.nativeElement.focus();
        break;
    }
  }
}
